import { Fragment, useCallback, useRef } from 'react'
import { bool, func, object, number } from 'prop-types'
import { BasePopoverConfermaOperazione } from 'feedback'
import { BaseScatolaConTitolo, BaseGridLayout, useModal, BaseModal, BaseDivider } from 'layout'
import { arricchisciPropOggetto, debounce, generaUUID, sx } from 'utils'
import { BaseButtons } from './BaseButtons'
import { BaseForm } from './BaseForm'
import useInputGenerico from './hooks/InputGenericoHook'
import useControllerSeServe from './hooks/ControllerSeServeHook'

BaseInputListaElementi.propTypes = {
  FormElemento: func,
  FormElementoInterna: func,
  defaultValuesElemento: object,
  renderModalCreazione: func,
  propsModalCreazione: object,
  propsScatola: object,
  confermaEliminazione: bool,
  propsConfermaEliminazione: object,
  disabilitaCreazione: bool,
  disabilitaEliminazione: bool,
  numeroMaxElementi: number,
  conDivider: bool,
}

export default function BaseInputListaElementi(props) {
  const {
    // Passare FormElemento OPPURE FormElementoInterna
    FormElemento, // passare se non va bene la FormElementoStandard e serve più controllo dall'esterno
    FormElementoInterna, // passare se va bene la FormElementoStandard (caso più semplice)
    defaultValuesElemento,
    renderModalCreazione,
    propsModalCreazione,
    propsScatola,
    confermaEliminazione = true,
    propsConfermaEliminazione,
    disabilitaCreazione,
    disabilitaEliminazione,
    numeroMaxElementi,
    conDivider,
    ...restProps
  } = props

  const {
    label,
    hidden,
    disabled,
    ...inputGenericoProps
  } = useInputGenerico({
    componenteControllato: true,
    underlyingComponent: 'lista',
    ...restProps,
  })

  const {
    value: listaOriginale,
    // onBlur,
    onChange,
    // ref,
    propsRimanenti,
  } = useControllerSeServe(inputGenericoProps)

  const lista = listaOriginale.map(
    elemento => elemento.uuid ? elemento : { ...elemento, uuid: generaUUID() }
  )

  function aggiungi(elemento) {
    onChange([...lista, { ...defaultValuesElemento, uuid: generaUUID(), ...elemento }])
  }

  function modifica(uuidDaModificare, valoreDaUnire) {
    onChange(lista.map(
      elemento => elemento.uuid === uuidDaModificare ? { ...elemento, ...valoreDaUnire } : elemento)
    )
  }

  function elimina(uuidDaEliminare) {
    onChange(lista.filter(elemento => elemento.uuid !== uuidDaEliminare))
  }

  const { modalRef, openModal, closeModal } = useModal()

  function iniziaCreazione() {
    if (renderModalCreazione) openModal()
    else aggiungi()
  }

  function aggiungi_EChiudiModal(nuovoElemento) {
    aggiungi(nuovoElemento)
    setTimeout(() => closeModal())
  }

  const funzioniModalCreazione = {
    onCancel: closeModal,
    onSubmit: aggiungi_EChiudiModal
  }

  const numeroMaxRaggiunto = numeroMaxElementi ? lista.length >= numeroMaxElementi : false
  const mostraCreazione = !disabled && !disabilitaCreazione && !numeroMaxRaggiunto

  return (
    <BaseScatolaConTitolo
      titolo={label}
      {...propsScatola}
      {...arricchisciPropOggetto(propsScatola, 'propsTitolo', { colorato: false })}
      {...sx(propsScatola, { ...(hidden && { display: 'none' }), mt: 2, py: 1 })}
    >
      {lista.map(({ uuid, ...valori }, index) => {
        const propsFormElemento = {
          defaultValues: valori,
          onChange: nuoviValori => modifica(uuid, nuoviValori),
          readOnly: disabled,
        }
        return (
          <Fragment key={uuid}>
            <BaseGridLayout alignCenter>
              {FormElementoInterna ? (
                <FormElementoStandard {...propsFormElemento}>
                  <FormElementoInterna {...propsRimanenti} />
                </FormElementoStandard>
              ) : (
                <FormElemento {...propsFormElemento} {...propsRimanenti} />
              )}

              {!disabled && !disabilitaEliminazione && (
                confermaEliminazione ? (
                  <BasePopoverConfermaOperazione
                    messaggio="Confermare l'eliminazione?"
                    onConferma={() => elimina(uuid)}
                    {...propsConfermaEliminazione}
                  >
                    <BaseButtons.Elimina
                      variant='text'
                      size='small'
                      noMarginY
                      sx={{ mt: 1 }}
                    />
                  </BasePopoverConfermaOperazione>
                ) : (
                  <BaseButtons.Elimina
                    onClick={() => elimina(uuid)}
                    variant='text'
                    size='small'
                    noMarginY
                    sx={{ mt: 1 }}
                  />
                )
              )}
            </BaseGridLayout>

            {conDivider && (mostraCreazione || index !== lista.length - 1) &&
              <BaseDivider sx={{ mt: 2, mb: 1 }} />
            }
          </Fragment>
        )
      })}

      {mostraCreazione &&
        <BaseButtons.Aggiungi
          onClick={iniziaCreazione}
          color='success'
          variant='text'
          size='small'
        />
      }

      {renderModalCreazione &&
        <BaseModal
          ref={modalRef}
          {...propsModalCreazione}
        >
          {renderModalCreazione(funzioniModalCreazione)}
        </BaseModal>
      }
    </BaseScatolaConTitolo>
  )
}



function FormElementoStandard(props) {
  const { onChange, children, ...restProps } = props

  const formRef = useRef()

  const inviaValoriForm_Ref = useRef(onChange)
  inviaValoriForm_Ref.current = onChange

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const inviaValoriForm_ConRitardo = useCallback(
    debounce(() => {
      const valoriCampiRegistrati = formRef.current.watch()
      inviaValoriForm_Ref.current(valoriCampiRegistrati)
    }, 500),
    []
  )

  return (
    <BaseForm
      ref={formRef}
      onChangeTuttiCampi={inviaValoriForm_ConRitardo}
      nonUsareFormTagHtml
      {...restProps}
    >
      {children}
    </BaseForm>
  )
}